import {
    DirectPromotionCampainUI,
    DirectPromotionDto,
    DirectPromotionUI,
    DirectSpendLimitType,
} from '../../data-layer/direct/types';
import { disableContentPromotionGoalsCost } from '../../utils/disableContentPromotionGoalsCost';

export const toPromotionDto = (data: DirectPromotionUI): DirectPromotionDto => {
    const { businessId, campaign, feedSettings } = data;
    const { goals } = campaign;
    const goalsIds = Object.keys(campaign.goals);
    const regionsIds = Object.keys(campaign.regions).map((id) => Number(id));

    return {
        business_id: businessId,
        campaign_data: {
            start_date: campaign.startDate,
            weekly_limit: campaign.weeklyLimit,
            region_ids: regionsIds,
            counter_ids: campaign.counters,
            goals: goalsIds.map((id) => {
                const cost = goals[id] ?? 0;

                return {
                    goal_id: id,
                    cost: disableContentPromotionGoalsCost(campaign.spendLimitType) ? 0 : cost,
                };
            }),
            login: campaign.login,
            tracking_params: campaign.utmParams,
            strategy_type: campaign.strategyType,
            pay_for: campaign.payFor,
            budget_type: campaign.budgetType,
            spend_limit_type: campaign.spendLimitType,
            ...getSpendLimitAmount(campaign),
        },
        feed_settings: {
            banned_post_ids: feedSettings.posts,
            use_all_posts: feedSettings.useAllPosts,
            freshness_days: feedSettings.freshnessDays ?? 0,
        },
    };
};

export const getSpendLimitAmount = (campaign: DirectPromotionCampainUI) => {
    if (campaign.spendLimitType === DirectSpendLimitType.AVERAGE_CPC) {
        return {
            average_cpc: campaign.spendLimitAmount,
        };
    }

    if (campaign.spendLimitType === DirectSpendLimitType.CRR) {
        return {
            crr: campaign.spendLimitAmount,
        };
    }

    // дополнительных полей не требуется
    return {};
};
